module.exports = __webpack_public_path__ + "static/media/LIft.c31df33b.png";